/**
 * CR308-B: Lightweight hook to fetch WEB_CRAWL recipe names for table display.
 * Returns a map of recipe_id → recipe_name.
 */

import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useWebRecipeNames(): Record<string, string> {
  const [nameMap, setNameMap] = useState<Record<string, string>>({});

  useEffect(() => {
    const load = async () => {
      const { data, error } = await supabase
        .from("capture_recipe_templates")
        .select("id, recipe_name")
        .eq("recipe_scope", "WEB_CRAWL")
        .eq("is_archived", false)
        .order("recipe_name");

      if (!error && data) {
        const map: Record<string, string> = {};
        for (const r of data) {
          map[r.id] = r.recipe_name;
        }
        setNameMap(map);
      }
    };
    load();
  }, []);

  return nameMap;
}
